import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './homeHero.css';
import './heroSlogan.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance, pass a function
// to log results, or send to an analytics endpoint.
reportWebVitals();
